import React from "react";
import { CloudEntry } from "../../model/cloud/CloudEntry.js";
import { ListItem } from "../../../packages/ui/list/ListItem.js";
import { useCloud } from "./CloudProvider.js";
import { FileIcon } from "../../../icons/FileIcon.js";
import { FolderIcon } from "../../../icons/FolderIcon.js";
import { Link } from "../../../packages/router/Link.js";
import { isSyncDirectory } from "./isSyncDirectory.js";
import { Buttons } from "../../../packages/ui/form/Buttons.js";
import { Button } from "../../../packages/ui/button/Button.js";
import { DeleteIcon } from "../../../icons/DeleteIcon.js";
import { joinPath } from "./joinPath.js";

type Props = {
  entry: CloudEntry;
};

/**
 * Displays a cloud directory or file.
 */
export const CloudEntryItem = ({ entry }: Props) => {
  const { directory, removePath } = useCloud();

  const path = joinPath(directory, entry.name);

  return (
    <ListItem>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "0.25rem",
            alignItems: "center"
          }}
        >
          {entry.type === "file" ? (
            <>
              <FileIcon />
              <a target="_blank" rel="noreferrer" href={`/api/cloud/file${path}`}>
                {entry.name}
              </a>
            </>
          ) : (
            <>
              <FolderIcon />
              <Link to={`/cloud?directory=${path}`}>{entry.name}</Link>
            </>
          )}
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "0.25rem",
            alignItems: "center"
          }}
        >
          {entry.type === "file" && <div>{(entry.size / 1024 / 1024).toFixed(2)} MB</div>}
          {!isSyncDirectory(path) && (
            <Buttons>
              <Button size="icon" onClick={() => removePath(path)}>
                <DeleteIcon />
              </Button>
            </Buttons>
          )}
        </div>
      </div>
    </ListItem>
  );
};
